exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".booking-request{display:flex;flex-direction:column}.booking-request strong{line-height:1em;font-size:28px;display:block;font-weight:700}@media(max-width:767px){.booking-request strong{font-size:16px}}.booking-request p{padding-top:5px;font-size:14px;color:#8d9aa5}", ""]);

